module.exports = __webpack_public_path__ + "img/107ef02.webp";